import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

import { MgButtonModule } from '@app/src/app/button';
import { EventGoingStateModule } from '@app/src/app/components/EventGoingState';
import { GalleryPhotoEventStreamModule } from '@app/src/app/components/GalleryPhotoEventStream';
import { MgImageModule } from '@app/src/app/components/MgImage';
import { EventPeopleModule } from '@app/src/app/components/Overlay/EventPeople';
import { PointsBannerModule } from '@app/src/app/components/Points/PointsBanner';
import { PhotoGalleryAddPhotoModule } from '@app/src/app/components/TopOfFeed/PhotoGalleryAddPhoto';
import { PhotoGalleryPreviewModule } from '@app/src/app/components/TopOfFeed/PhotoGalleryPreview';
import { MgContentLinkModule } from '@app/src/app/content-link';
import { MgAvatarModule } from '@app/src/app/elements/MgAvatar';
import { MgDateBadgeModule } from '@app/src/app/elements/MgDateBadge';
import { MgEllipsisModule } from '@app/src/app/elements/MgEllipsis';
import { MgPersonMinimalModule } from '@app/src/app/elements/MgPersonMinimal';
import { MgIconModule } from '@app/src/app/icon';
import { MgOverlayToolsModule } from '@app/src/app/overlay/tools';
import { PermissionsModule } from '@app/src/app/permissions';
import { MgPipesModule } from '@app/src/app/pipes';
import { UgcLinksContentPipeModule } from '@app/src/app/ugc-links/pipes/UgcLinksContent';

import { GenericButtonModule } from '@shared/components/button';
import { GenericModule } from '@shared/components/generic';
import { MembershipListTableModule } from '@shared/components/membership-list-table';

import { LongCardBaseModule } from '../LongCardBase';
import { EventLongCardComponent } from './EventLongCard.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgDateBadgeModule,
    MgButtonModule,
    MgAvatarModule,
    MgPersonMinimalModule,
    MgEllipsisModule,
    MgPipesModule,
    LongCardBaseModule,
    MgImageModule,
    UgcLinksContentPipeModule,
    PermissionsModule,
    PhotoGalleryPreviewModule,
    PhotoGalleryAddPhotoModule,
    MgOverlayToolsModule,
    MgContentLinkModule,
    MgIconModule,
    PointsBannerModule,
    EventGoingStateModule,
    GalleryPhotoEventStreamModule,
    GenericButtonModule,
    GenericModule,
    MembershipListTableModule,
    EventPeopleModule,

    // External dependencies
    CommonModule,
    FormsModule,
    FlexLayoutModule,
    RouterModule,
    MatIconModule,
  ],
  declarations: [EventLongCardComponent],
  exports: [EventLongCardComponent],
})
export class EventLongCardModule {}
